// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.st-theme-container {
    margin-top: 0px;
}


.st-select-theme-container {
    margin-top: 10px;
    margin-left: 50px;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
}

.st-themes-dropdown {
    width: 30%;
    height: 40px;
    margin-top: -10px;
    font-family: Arial, Helvetica, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/SelectThemes.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;AAC7C","sourcesContent":[".st-theme-container {\n    margin-top: 0px;\n}\n\n\n.st-select-theme-container {\n    margin-top: 10px;\n    margin-left: 50px;\n    font-size: 18px;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.st-themes-dropdown {\n    width: 30%;\n    height: 40px;\n    margin-top: -10px;\n    font-family: Arial, Helvetica, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
